import { vehicleStatusColorMap } from 'constants/inventory'
import type { StatusTone } from 'core/theme.tokens'

const muiColorToTone = (color: string | undefined): StatusTone => {
  switch (color) {
    case 'success':
      return 'success'
    case 'error':
      return 'danger'
    case 'warning':
      return 'warning'
    case 'info':
      return 'info'
    case 'secondary':
      return 'purple'
    default:
      return 'neutral'
  }
}

/** Maps inventory vehicle status strings to shared StatusChip tones. */
export const vehicleInventoryStatusTone = (status: string | undefined | null): StatusTone => {
  if (!status) return 'neutral'
  const config = vehicleStatusColorMap[status] ?? vehicleStatusColorMap.default
  return muiColorToTone(config.color)
}

const dealQualityToTone: Record<string, StatusTone> = {
  great: 'success',
  good: 'info',
  average: 'neutral',
  belowAverage: 'warning',
  poor: 'danger',
}

export const vehicleDealQualityTone = (quality: string | undefined | null): StatusTone => {
  if (!quality) return 'neutral'
  return dealQualityToTone[quality.toLowerCase()] ?? 'neutral'
}
